import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import { unpackToDateTime } from '@campfire/hot-date';
import { useVolunteerCommonProfileContext } from '../../VolunteerCommonProfileContext';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { GET_VOLUNTEER_FORM_SUBMISSIONS } from './volunteer-forms-section.gql';

interface Props {
  profileId: string;
}

export const VolunteerFormsSection = ({ profileId }: Props) => {
  const {
    volunteerNameOptions: { preferredName },
  } = useVolunteerCommonProfileContext();

  const { data } = useCampfireQuery<any, { profileId: string }>(GET_VOLUNTEER_FORM_SUBMISSIONS, {
    options: { variables: { profileId } },
  });

  const submissions = data?.vm?.profile?.formSubmissions ?? [];

  return (
    <Grid container spacing={2} direction='column' style={{ position: 'relative' }}>
      <Grid item xs={12} style={{ textAlign: 'left' }}>
        <Box>
          <Typography
            style={{ fontWeight: 600, fontSize: '18px', display: 'flex', alignItems: 'center', color: '#333' }}
          >
            <Description style={{ fontSize: '14px', paddingRight: '5px' }} /> Forms
          </Typography>
          <Typography variant='body2' style={{ color: '#464646' }} align='left'>
            Forms and surveys {preferredName} has submitted
          </Typography>
        </Box>
        <hr style={{ borderTop: '.5px solid #e7e7e7', margin: '20px 0' }} />
        {submissions.map((submission: any) => (
          <Box
            key={submission.formSubmissionId}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 16px',
              border: '1px solid #e7e7e7',
              borderRadius: '4px',
              marginBottom: '10px',
            }}
          >
            <Box>
              <Typography style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                {submission.form?.title ?? 'Untitled form'}
              </Typography>
              <Typography variant='body2' style={{ color: '#767676', fontSize: '13px' }}>
                Submitted {unpackToDateTime(submission.submissionDate).toFormat('d MMM yyyy')}
              </Typography>
            </Box>
            <a
              href={`/admin/forms/responses?fid=${submission.form?.formId}`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontSize: '13px', fontWeight: 600, color: '#1565c0', textDecoration: 'none' }}
            >
              View
            </a>
          </Box>
        ))}
        {submissions.length === 0 && (
          <Typography
            variant='body2'
            style={{ fontSize: '13px', color: '#494949', textAlign: 'center', padding: '2rem 0' }}
          >
            No forms submitted yet
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
